Ext.define('SA.VectorMapExportLegend', {
    singleton: true,

    margin: 10,
    minWidth: 150,
    rangeRowGap: 5,
    rowGap: 7.5,

    attributes: {
        businessPoint: {
            cx: 15,
            cy: 10,
            fill: 'rgb(248, 204, 118)',
            r: 10,
            stroke: 'rgb(159, 96, 66)'
        },

        businessSearch: {
            x: 13
        },

        rangeRect: {
            height: 20,
            width: 30
        },

        rangeText: {
            dominantBaseline: 'hanging',
            x: 8
        },

        separator: {
            stroke: '#dddede',
            strokeWidth: 1
        }
    },

    fontStyle: {
        fontFamily: 'Verdana, sans-serif',
        fontSize: '12px',
        fontVariantLigatures: 'no-common-ligatures'
    },

    getSvg({backgroundColor, fontColor, height, modelState, width}) {
        var createSeparator = width => SA.Svg.create({type: 'line', x2: width, ...this.attributes.separator}),
            {attributes, businessSearch, geoUnits, legendBreaks, legendSettings} = modelState,
            attribute = attributes.selected,
            contentWidth = this.minWidth,
            content = [],
            ranges;

        if (attribute) {
            let {breaks, colors} = legendBreaks,
                {maximum, minimum, outline} = legendSettings,
                {formatString, increments} = SA.data.AttributesCache.get(attribute),
                geographicUnit = SA.data.GeographicUnits.get(geoUnits.selected);

            ranges = SA.SvgLinearLayout.create({
                gap: this.rangeRowGap,
                vertical: true,

                content: colors.map((color, i) => {
                    var lower = SA.data.AttributesCache.formatValue(i === 0 ? minimum : breaks[i - 1], formatString),
                        upper = SA.data.AttributesCache.formatValue(i < breaks.length ? breaks[i] - increments : maximum, formatString);

                    return SA.SvgLinearLayout.create({
                        center: true,

                        content: [
                            {
                                type: 'rect',
                                fill: `#${color}`,
                                stroke: `#${outline.color}`,
                                ...this.attributes.rangeRect
                            }, {
                                type: 'text',
                                content: `${lower} - ${upper}`,
                                fill: fontColor,
                                style: this.fontStyle,
                                ...this.attributes.rangeText
                            }
                        ]
                    });
                })
            });

            contentWidth = Math.max(contentWidth, SA.Svg.getRect(ranges).width);

            content.push(SA.Svg.wrapText({
                content: `${SA.data.AttributesCache.getLabel(attribute)} by ${geographicUnit.name}`,
                style: {color: fontColor, width: `${contentWidth}px`, ...this.fontStyle}
            }));

            content.push(createSeparator(contentWidth));
        }

        if (businessSearch) {
            content.push(SA.SvgLinearLayout.create({
                center: true,

                content: [
                    {
                        type: 'circle',
                        ...this.attributes.businessPoint
                    },
                    SA.Svg.wrapText({
                        content: SA.data.BusinessSearches.get(businessSearch).name,
                        ...this.attributes.businessSearch,

                        style: {
                            color: fontColor,
                            width: `${contentWidth - this.attributes.businessPoint.cx - this.attributes.businessPoint.r - this.attributes.businessSearch.x}px`,
                            ...this.fontStyle
                        }
                    })
                ]
            }));

            content.push(createSeparator(contentWidth));
        }

        if (ranges) {
            content.push(ranges);
        }

        return SA.Svg.wrap({
            backgroundColor,
            content: SA.SvgLinearLayout.create({content, gap: this.rowGap, vertical: true}),
            height,
            margin: this.margin,
            width
        });
    }
});